<template>
  <header class="flex items-center justify-between gap-4">
    <span class="font-size-5 font-500 line-height-8 tracking-[0.25px]">{{ t('canvasUI.agendaSelector.title') }}</span>

    <CButton class="rounded h-11 w-11" @click="emit('close')">
      <template #icon>
        <CIcon icon="close" size="16" />
      </template>
    </CButton>
  </header>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import CButton from '@lib/components/CButton/CButton.vue'
import CIcon from '@lib/components/CIcon/CIcon.vue'

const emit = defineEmits<{
  close: []
}>()

const { t } = useI18n()
</script>
